import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <path d="M1.75 18.216a.75.75 0 0 1-.75-.75V8.601a.75.75 0 0 1 1.5 0v8.865a.75.75 0 0 1-.75.75zM14.72 10.53c0 .28.22.5.5.5h2.55L17.41 13h-2.19c-.28 0-.5.22-.5.5s.22.5.5.5h2.01l-.37 2h-1.64c-.28 0-.5.22-.5.5s.22.5.5.5h1.46l-.12.64c-.13.78-.82 1.36-1.62 1.36H5.66C4.74 19 4 18.26 4 17.34V9.13c0-.92.74-1.66 1.66-1.66h.19c.22 0 .42-.14.51-.32l2.29-5.18C9 1.18 9.91.8 10.72 1.1a2.71 2.71 0 0 1 1.73 2.79l-.29 2.98c-.02.15.03.3.13.41.11.12.25.19.42.19h3.45c.92 0 1.66.74 1.66 1.66v.9h-2.6c-.28 0-.5.23-.5.5z" />
);

const Icon = createSvgIcon(svg, 'ThumbUpFill');

export default Icon;
